module.exports = require("./hyphen.js");



//////////////////
// WEBPACK FOOTER
// ./~/hyphen/index.js
// module id = 813
// module chunks = 0